import { useTranslation } from 'react-i18next';

import KitoContentSection from '../../../components/DataDisplay/ContentSection';
import KitoBuddy from '../../../components/Buddy';

import ADULTSIGNSANDSYMPTOMSIMAGES from '../../../assets/designSystem/icons/StaticPages/Symptoms';

export default function WhatToDo({ title, options = [] }) {
  const { t } = useTranslation();
  return (
    <>
      <KitoBuddy image="whatToDo">{t(title)}</KitoBuddy>
      <KitoContentSection variant="orange-border">
        {options.map((option) => (
          <div key={option.label} className="whattodo__content">
            <div className="symptoms__cont">
              <img
                src={ADULTSIGNSANDSYMPTOMSIMAGES[option.icon]}
                alt="symptoms"
              />
            </div>
            <p>{t(option.label)}</p>
          </div>
        ))}
      </KitoContentSection>
    </>
  );
}
